import {createContext, useReducer} from "react";

export const CasteContext = createContext();

export const casteReducer = (state,action) => {
    switch(action.type){
        case 'SET_CASTES':
            return {
                castes: action.payload
            }
        
        case 'CREATE_CASTE':
            return {
                castes: [action.payload.caste,...state.castes]
            }

        case 'DELETE_CASTE':
            return {
                castes: state.castes.filter((caste) => caste._id !== action.payload._id)
            }

        default:
            return state
    }
}

export const CasteContextProvidor = ({children}) =>{
    const [state,dispatch] = useReducer(casteReducer,{
        castes: null,
    });

    return (
        <CasteContext.Provider value={{...state,dispatch}}>
            {children}
        </CasteContext.Provider>
    )
}